import isPes from "src/helpers/isPes";

import ExamTypeFilter from "./ExamTypeFilter/ExamTypeFilter";

export default function ExamFilter(props) {
	if (isPes()) {
		return null;
	}

	return <ExamTypeFilter {...props} />;
}
